import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';

const DEVICE_SCOPE = '__device__';
const NAMESPACE = 'device_label';
const LEGACY_KEY = 'nexxus.deviceLabel';
const DEFAULT = 'Poste non nommé';

/** Libellé du poste (SQLite chiffré ou localStorage legacy). */
export async function getDeviceLabel(): Promise<string> {
  const label = await SecureTenantStore.getJson<string>(
    DEVICE_SCOPE,
    NAMESPACE,
    DEFAULT,
    LEGACY_KEY,
  );
  return label.trim() || DEFAULT;
}

export async function setDeviceLabel(label: string): Promise<void> {
  const trimmed = label.trim();
  if (!trimmed) return;
  await SecureTenantStore.setJson(DEVICE_SCOPE, NAMESPACE, trimmed, LEGACY_KEY);
}
